import React from "react";

type PortfolioEmptyStateProps = {
  filter: string;
  onSwitchToAll?: () => void;
};

const ShieldIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M12 3L19 6V11.5C19 16.2 15.7 20.6 12 21C8.3 20.6 5 16.2 5 11.5V6L12 3Z"
      stroke="#4CAF50"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);

const getContent = (filter: string) => {
  if (filter === "enabled") {
    return {
      title: "No portfolios have Vero Go enabled",
      body: "Enable Vero Go on a portfolio to automatically apply it to all of its inherited properties.",
    };
  }

  if (filter === "disabled") {
    return {
      title: "No portfolios have Vero Go disabled",
      body: "Disable Vero Go on a portfolio if you want inherited properties to stop using Vero Go settings.",
    };
  }

  return {
    title: "No portfolios available",
    body: "Create or assign a portfolio to begin configuring Vero Go.",
  };
};

const PortfolioEmptyState = ({ filter, onSwitchToAll }: PortfolioEmptyStateProps) => {
  const content = getContent(filter);

  return (
    <div
      style={{
        border: "1px dashed #d9d9d9",
        borderRadius: 12,
        background: "#fafafa",
        padding: "48px 24px",
        textAlign: "center",
      }}
    >
      <div style={{ fontSize: 18, fontWeight: 600, color: "#1f2937", marginBottom: 10 }}>
        {content.title}
      </div>
      <div
        style={{
          fontSize: 14,
          color: "#6b7280",
          maxWidth: 540,
          margin: "0 auto",
          lineHeight: 1.5,
        }}
      >
        {content.body}
      </div>
      {(filter === "enabled" || filter === "disabled") && (
        <button
          type="button"
          onClick={onSwitchToAll}
          style={{
            marginTop: 18,
            border: "none",
            borderRadius: 999,
            padding: "8px 16px",
            background: "#f3f4f6",
            color: "#9ca3af",
            fontSize: 14,
            fontWeight: 500,
            cursor: "pointer",
          }}
        >
          Switch to &quot;All&quot; to see and configure portfolios
        </button>
      )}
    </div>
  );
};

export default PortfolioEmptyState;
